// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phoneType__msignaturepad___1aGt7","m-signature-pad--body":"phoneType__m-signature-pad--body___K--x2","m-signature-pad--footer":"phoneType__m-signature-pad--footer___3APNE","description":"phoneType__description___3Ky0s","button":"phoneType__button___31za4","clear":"phoneType__clear___1N4_W","save":"phoneType__save___e3T2b","m-signature-pad":"phoneType__m-signature-pad___OhG2v","github":"phoneType__github___1u_rA","phoneTypes":"phoneType__phoneTypes___3kHyt","phone":"phoneType__phone___1tH64","selected":"phoneType__selected___2WGM8"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/PhoneType/phoneType.scss
// module id = 1krR
// module chunks = client